import React from 'react'
import T from 'prop-types'
import { Box, Stack, Typography } from '@mui/material'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'

export default function UploadedFileName({ fileName, uploaded }) {
  return (
    <>
      {uploaded && (
        <Stack direction="row" alignItems="center">
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              border: (theme) => `1px solid ${theme.palette.action.disabled}`,
              borderRadius: 1,
              p: 0.5,
            }}
          >
            <DescriptionOutlinedIcon />
          </Stack>
          <Box pr={1} />
          <Typography variant="body2" color="textPrimary">
            <span>{fileName}</span>
          </Typography>
          <Box pr={2} />
        </Stack>
      )}
    </>
  )
}

UploadedFileName.propTypes = {
  fileName: T.string,
  uploaded: T.bool,
}
